import { useEffect, useRef, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import api from '../services/api';

const VerifyEmail = () => {
    const { token } = useParams();
    const [loading, setLoading] = useState(true);
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const yaVerificado = useRef(false);

    useEffect(() => {
        console.log('🟢 VerifyEmail montado con token:', token);

        if (yaVerificado.current) return;
        yaVerificado.current = true;

        const verify = async () => {
            try {
                console.log('📤 Llamando a /auth/verify-email/' + token);
                const res = await api.get(`/auth/verify-email/${token}`);
                console.log('✅ Respuesta del backend:', res.data);
                setMessage(res.data.message || 'Cuenta verificada exitosamente.');
            } catch (err) {
                console.error('❌ Error en verificación:', err.response?.data || err.message);
                setError(err.response?.data?.message || 'Error al verificar el correo');
            } finally {
                setLoading(false);
            }
        };
        verify();
    }, [token]);

    if (loading) return <div className="verify-wrapper"><div className="verify-box">Verificando...</div></div>;

    return (
        <div className="verify-wrapper">
            <div className="verify-box">
                {message && <div className="alert alert-success">{message}</div>}
                {error && <div className="alert alert-danger">{error}</div>}
                <Link to="/login">Ir al inicio de sesión</Link>
            </div>
        </div>
    );
};

export default VerifyEmail;